<div class="child" *ngIf="hasSalvage">Vehicle Recorded as Salvaged</div>
<div class="child" *ngIf="ancestryCategory">Vehicle Recorded as Ancestry: {{ancestryCategory}}</div>